import { STATUS_TYPE } from '../../../enum';
// import { Country } from '../../country/api/interface';
// import { Region } from '../../region/api/interface';

export interface CreateUsers {
    firstName: string,
    lastName: string,
    email: string,
    mobileNumber: string,
    countryCallingCode: string
    userRole: string,
    // language: string,
    // countryId: string,
    // regionId: string,
}

export interface CreateCustomer {
    firstName: string;
    lastName?: string;
    email?: string;
    mobileNumber: string;
    countryCallingCode: string;
    gender?: 'male' | 'female';
    birthDate?: string; // ISO optional
    language?: 'en' | 'ar';
    countryCode: string;
    regionCode?: string;
}

export interface UpdateUserProfile {
    id: string;
    firstName: string;
    lastName: string;
    activeState: boolean;
    countryCallingCode?: string;
    mobileNumber?: string;
    email?: string;
    userRole?: string;
    allowNotification?: boolean;
    // language: string
    // countryId: string
    // regionId: string
}

export interface UpdateUserPassword {
    id: string;
    oldPassword: string;
    newPassword: string;

}

export interface GetUsers {
    organizationId: string;
    limit: number;
    skip: number;
}

export interface FindUsers {
    id: string;
    organizationId: string;
}

export interface FindUserList {
    isUser?: boolean;
    search?: string;
    limit?: number;
    skip?: number;
}

export interface RemoveUsers {
    id: string;
    organizationId: string;
}
export interface Users {
    id: string;
    firstName: string;
    lastName: string;
    mobileNumber: string;
    email: string;
    balance: string;
    // countryCode: string;
    countryCallingCode: string;
    language: string;
    // countryId: string;
    // country: Country
    // regionId: string;
    // region: Region;
    allowNotification: boolean;
    activeState: boolean;
    userRole: string;
    createdAt: string;
    updatedAt: string;
    user_nationality_inferences?: Array<{
        id: string;
        fullName: string;
        primaryCountry: string | null;
        confidence: number | null;
        certainty: string | null;
        nameOrigin: string | null;
    }>;
}

export interface InitialState {
    data: Users[];
    skip: number;
    limit: number;
    totalRecords: number;
    currentPage: number;
    status: STATUS_TYPE;
    isError: boolean;
    isLoading: boolean;
    isSuccess: boolean;
    errorMessage: string;
}

export const initialState: InitialState = {
    data: [],
    skip: 0,
    limit: 25,
    totalRecords: 0,
    currentPage: 0,
    status: 'idle',
    isError: false,
    isLoading: false,
    isSuccess: false,
    errorMessage: '',
};
